<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'read',
    subject: 'UserGuide',
  },
})

const notifTypes = [
  {
    icon: 'ri-alert-line',
    color: 'warning',
    judul: 'Stok Bahan Baku Menipis',
    kapan: 'Setiap hari jam 08.00 pagi',
    isi: 'Sistem mengecek semua bahan baku. Jika ada yang stoknya di bawah "Stok Minimum", notifikasi dikirim ke Owner dan Manager.',
    contoh: 'Stok Menipis (3 bahan baku) — Kopi Arabika, Susu UHT, Gula Aren',
    aksi: 'Klik notifikasi → langsung diarahkan ke halaman Bahan Baku',
  },
]

const exportTypes = [
  {
    nama: 'Laporan Penjualan Excel',
    format: 'xlsx',
    icon: 'ri-file-excel-2-line',
    color: 'success',
    isiFile: 'Tabel per hari/minggu/bulan: jumlah order, item terjual, diskon, dan total omzet',
    cocokUntuk: 'Analisa di spreadsheet, kirim ke akuntan, arsip bulanan',
  },
  {
    nama: 'Laporan Penjualan PDF',
    format: 'pdf',
    icon: 'ri-file-pdf-2-line',
    color: 'error',
    isiFile: 'Sama dengan Excel, tapi siap cetak dengan layout rapi format A4 landscape',
    cocokUntuk: 'Presentasi ke investor, laporan ke bank, arsip fisik',
  },
  {
    nama: 'Laba Rugi Excel',
    format: 'xlsx',
    icon: 'ri-file-excel-2-line',
    color: 'success',
    isiFile: 'Omzet, HPP, laba kotor, pengeluaran operasional, laba bersih, dan persentase margin',
    cocokUntuk: 'Analisa mendalam profitabilitas, laporan ke akuntan',
  },
  {
    nama: 'Laba Rugi PDF',
    format: 'pdf',
    icon: 'ri-file-pdf-2-line',
    color: 'error',
    isiFile: 'Format Profit & Loss Statement standar, siap cetak format A4 portrait',
    cocokUntuk: 'Laporan keuangan formal, pengajuan kredit, presentasi',
  },
]

const faqNotif = [
  {
    q: 'Kenapa saya tidak menerima notifikasi stok menipis padahal stok sudah habis?',
    a: 'Pastikan Anda sudah mengisi angka "Stok Minimum" di setiap bahan baku. Jika Stok Minimum diisi 0 atau dikosongkan, sistem tidak tahu batas minimal Anda dan tidak akan mengirim peringatan. Buka Inventory → Bahan Baku → Edit setiap bahan dan isi kolom "Stok Minimum".',
  },
  {
    q: 'Notifikasi muncul terus setiap hari untuk bahan yang sama. Bagaimana menghilangkannya?',
    a: 'Cara satu-satunya menghilangkan notifikasi stok adalah dengan menambah stok bahan baku tersebut melebihi angka Stok Minimum. Tandai notifikasi sebagai "dibaca" untuk menyembunyikannya sementara, tapi notifikasi baru tetap muncul keesokan harinya jika stok belum diisi.',
  },
  {
    q: 'Bisakah saya ubah jam pengiriman notifikasi dari jam 08.00 ke jam lain?',
    a: 'Saat ini jam pengiriman notifikasi (08.00 pagi) diatur oleh sistem dan tidak bisa diubah melalui tampilan aplikasi. Jika Anda butuh perubahan jadwal, hubungi tim support PintuKasir.',
  },
  {
    q: 'Apakah notifikasi juga dikirim ke email?',
    a: 'Ya! Selain muncul di ikon lonceng di aplikasi, notifikasi stok menipis juga dikirim ke email yang terdaftar sebagai Owner dan Manager. Pastikan alamat email di profil akun Anda sudah benar.',
  },
  {
    q: 'Saya klik "Tandai Semua Dibaca" tapi notifikasi masih banyak. Normal?',
    a: '"Tandai Semua Dibaca" hanya mengubah status tampilan (notifikasi tidak lagi tebal/highlight). Notifikasi tidak dihapus dari daftar. Untuk menghapus, klik tombol X di tiap notifikasi satu per satu.',
  },
]

const faqExport = [
  {
    q: 'File Excel hasil download tidak bisa dibuka. Apa yang salah?',
    a: 'Pastikan Anda punya aplikasi Microsoft Excel atau Google Sheets di perangkat Anda. File berekstensi .xlsx membutuhkan aplikasi spreadsheet untuk dibuka. Di smartphone, gunakan aplikasi Google Sheets (gratis) atau Microsoft Excel mobile.',
  },
  {
    q: 'Apakah data yang sudah di-export terupdate otomatis?',
    a: 'Tidak. File yang sudah Anda download adalah "foto" data pada saat itu. Jika ada transaksi baru setelah Anda download, file lama tidak berubah. Anda perlu download ulang untuk data terbaru.',
  },
  {
    q: 'Kenapa tombol Export tidak bisa diklik?',
    a: 'Tombol Export akan nonaktif (abu-abu) jika tidak ada data di periode yang dipilih. Coba ubah rentang tanggal ke periode lain, lalu klik "Tampilkan" atau "Hitung" terlebih dahulu. Jika data sudah muncul di tabel, tombol Export akan aktif.',
  },
  {
    q: 'Berapa lama proses download file Excel/PDF?',
    a: 'Tergantung jumlah data dan kecepatan internet Anda. Untuk data 1 bulan biasanya kurang dari 5 detik. Untuk data 1 tahun bisa 10-30 detik. Jangan klik tombol lain atau tutup halaman saat download sedang berjalan — tunggu hingga file tersimpan di folder Downloads Anda.',
  },
  {
    q: 'Apakah bisa export data lebih dari 1 tahun sekaligus?',
    a: 'Secara teknis bisa — tidak ada batasan rentang tanggal. Namun, semakin besar rentang data, semakin lama proses download dan file yang dihasilkan akan lebih besar. Disarankan export per bulan atau per kuartal untuk performa terbaik.',
  },
]
</script>

<template>
  <div>
    <!-- Breadcrumb -->
    <VRow>
      <VCol cols="12">
        <div class="d-flex align-center gap-2 mb-2">
          <RouterLink to="/userguide" class="text-decoration-none text-medium-emphasis text-body-2">
            User Guide
          </RouterLink>
          <VIcon icon="ri-arrow-right-s-line" size="16" class="text-medium-emphasis" />
          <RouterLink to="/userguide/sistem" class="text-decoration-none text-medium-emphasis text-body-2">
            Sistem
          </RouterLink>
          <VIcon icon="ri-arrow-right-s-line" size="16" class="text-medium-emphasis" />
          <span class="text-body-2">Notifikasi & Export</span>
        </div>
      </VCol>
    </VRow>

    <!-- Header -->
    <VRow class="mb-2">
      <VCol cols="12">
        <div class="d-flex align-center mb-4">
          <VAvatar color="primary" variant="tonal" size="56" rounded="lg" class="me-3">
            <VIcon icon="ri-settings-3-line" size="30" />
          </VAvatar>
          <div>
            <h4 class="text-h4 font-weight-bold mb-0">Notifikasi & Export Laporan</h4>
            <p class="text-body-2 text-medium-emphasis mb-0">
              Panduan lengkap: lonceng notifikasi dan cara download laporan Excel & PDF
            </p>
          </div>
        </div>

        <VAlert type="info" variant="tonal" icon="ri-flag-line" class="mb-0">
          <strong>Tujuan halaman ini:</strong>
          Memandu Anda memahami sistem notifikasi otomatis PintuKasir (peringatan stok menipis)
          dan cara mendownload laporan penjualan serta laba rugi dalam format Excel dan PDF.
        </VAlert>
      </VCol>
    </VRow>

    <!-- ====================== BAGIAN 1: NOTIFIKASI ====================== -->
    <VRow class="mt-6">
      <VCol cols="12">
        <div class="d-flex align-center gap-3 mb-3">
          <VAvatar color="warning" variant="tonal" size="40" rounded>
            <VIcon icon="ri-notification-3-line" size="22" />
          </VAvatar>
          <h5 class="text-h5 font-weight-bold mb-0">Bagian 1 — Sistem Notifikasi</h5>
        </div>
      </VCol>
    </VRow>

    <!-- Konsep Notifikasi -->
    <VRow>
      <VCol cols="12">
        <VCard>
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-book-open-line" class="me-2" color="warning" />
            Apa itu Notifikasi dan Bagaimana Cara Kerjanya?
          </VCardTitle>
          <VCardText>
            <p class="text-body-2 mb-3">
              Di pojok kanan atas aplikasi, ada <strong>ikon lonceng 🔔</strong>.
              Jika ada angka merah di atasnya, berarti ada pesan penting yang belum Anda baca.
              Klik ikon tersebut untuk melihat daftar notifikasi.
            </p>

            <p class="text-body-2 mb-4">
              PintuKasir mengirim notifikasi <strong>otomatis</strong> — Anda tidak perlu
              melakukan apapun untuk mengaktifkannya. Sistem bekerja di balik layar dan
              langsung memberi tahu Anda saat ada sesuatu yang perlu diperhatikan.
            </p>

            <VAlert type="warning" variant="tonal" class="mb-0">
              <div class="d-flex align-start gap-2">
                <VIcon icon="ri-information-line" size="18" class="mt-1 flex-shrink-0" />
                <div>
                  <strong>Saat ini, PintuKasir mengirim 1 jenis notifikasi otomatis:</strong>
                  peringatan stok bahan baku yang menipis. Notifikasi lain (seperti target
                  penjualan tercapai) akan ditambahkan di pembaruan berikutnya.
                </div>
              </div>
            </VAlert>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- Notifikasi Stok Menipis -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VCard>
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-alert-line" class="me-2" color="warning" />
            Notifikasi: Stok Bahan Baku Menipis
          </VCardTitle>
          <VCardText>
            <VRow>
              <VCol cols="12" md="7">
                <p class="text-body-2 font-weight-medium mb-2">Bagaimana cara kerjanya:</p>
                <ol class="text-body-2 ps-4 mb-4">
                  <li class="mb-2">
                    Setiap hari jam <strong>08.00 pagi</strong>, sistem otomatis mengecek
                    stok semua bahan baku di toko Anda
                  </li>
                  <li class="mb-2">
                    Bahan baku yang stoknya <strong>di bawah angka Stok Minimum</strong>
                    yang Anda tentukan akan masuk daftar peringatan
                  </li>
                  <li class="mb-2">
                    Notifikasi dikirim ke <strong>semua pengguna berole Owner dan Manager</strong>
                    melalui 2 jalur:
                    <ul class="mt-1">
                      <li>Ikon lonceng 🔔 di aplikasi</li>
                      <li>Email ke alamat yang terdaftar</li>
                    </ul>
                  </li>
                  <li class="mb-0">
                    Klik notifikasi → Anda langsung diarahkan ke halaman
                    <strong>Bahan Baku</strong> untuk segera tindak lanjut
                  </li>
                </ol>

                <VAlert type="info" variant="tonal" density="compact">
                  <strong>Syarat agar notifikasi berfungsi:</strong> Kolom "Stok Minimum"
                  di setiap bahan baku harus diisi. Jika 0 atau kosong, sistem tidak tahu
                  kapan harus memberi peringatan.
                </VAlert>
              </VCol>

              <VCol cols="12" md="5">
                <!-- Simulasi tampilan notifikasi -->
                <VCard variant="outlined" class="pa-3">
                  <p class="text-caption text-medium-emphasis text-center mb-3">
                    Contoh tampilan notifikasi di aplikasi:
                  </p>
                  <div class="d-flex align-start gap-3 pa-3 rounded bg-warning-lighten-5 border border-warning mb-2">
                    <VAvatar color="warning" variant="tonal" size="36">
                      <VIcon icon="ri-alert-triangle-line" size="20" />
                    </VAvatar>
                    <div class="flex-grow-1">
                      <p class="text-body-2 font-weight-bold mb-0">
                        Stok Menipis (3 bahan baku)
                      </p>
                      <p class="text-caption text-medium-emphasis mb-0">
                        Kopi Arabika, Susu UHT, Gula Aren
                      </p>
                      <p class="text-caption text-disabled mb-0">Hari ini, 08:01</p>
                    </div>
                  </div>
                  <p class="text-caption text-medium-emphasis text-center mb-0">
                    Klik notifikasi → buka halaman Bahan Baku
                  </p>
                </VCard>
              </VCol>
            </VRow>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- Cara Kelola Notifikasi -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VCard>
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-list-settings-line" class="me-2" color="primary" />
            Cara Mengelola Notifikasi di Ikon Lonceng
          </VCardTitle>
          <VCardText>
            <VRow>
              <VCol cols="12" sm="6" md="3">
                <VCard variant="tonal" color="primary" class="pa-3 text-center h-100">
                  <VIcon icon="ri-notification-3-line" size="28" class="mb-2" />
                  <p class="text-body-2 font-weight-bold mb-1">Buka Notifikasi</p>
                  <p class="text-caption text-medium-emphasis mb-0">
                    Klik ikon lonceng 🔔 di pojok kanan atas. Angka merah = jumlah yang belum dibaca
                  </p>
                </VCard>
              </VCol>
              <VCol cols="12" sm="6" md="3">
                <VCard variant="tonal" color="success" class="pa-3 text-center h-100">
                  <VIcon icon="ri-check-double-line" size="28" class="mb-2" />
                  <p class="text-body-2 font-weight-bold mb-1">Tandai Dibaca</p>
                  <p class="text-caption text-medium-emphasis mb-0">
                    Klik satu notifikasi = otomatis ditandai dibaca. Atau klik "Tandai semua dibaca"
                  </p>
                </VCard>
              </VCol>
              <VCol cols="12" sm="6" md="3">
                <VCard variant="tonal" color="error" class="pa-3 text-center h-100">
                  <VIcon icon="ri-close-circle-line" size="28" class="mb-2" />
                  <p class="text-body-2 font-weight-bold mb-1">Hapus Notifikasi</p>
                  <p class="text-caption text-medium-emphasis mb-0">
                    Klik ikon X di ujung kanan tiap notifikasi untuk menghapusnya dari daftar
                  </p>
                </VCard>
              </VCol>
              <VCol cols="12" sm="6" md="3">
                <VCard variant="tonal" color="info" class="pa-3 text-center h-100">
                  <VIcon icon="ri-arrow-right-circle-line" size="28" class="mb-2" />
                  <p class="text-body-2 font-weight-bold mb-1">Navigasi Cepat</p>
                  <p class="text-caption text-medium-emphasis mb-0">
                    Notifikasi stok menipis: klik → langsung buka halaman Bahan Baku
                  </p>
                </VCard>
              </VCol>
            </VRow>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- FAQ Notifikasi -->
    <VRow class="mt-4">
      <VCol cols="12">
        <h6 class="text-h6 font-weight-bold mb-3">
          ❓ Pertanyaan Umum tentang Notifikasi
        </h6>
        <VExpansionPanels variant="accordion">
          <VExpansionPanel v-for="(item, i) in faqNotif" :key="i">
            <VExpansionPanelTitle class="text-body-2 font-weight-medium">
              {{ item.q }}
            </VExpansionPanelTitle>
            <VExpansionPanelText>
              <p class="text-body-2 mb-0">{{ item.a }}</p>
            </VExpansionPanelText>
          </VExpansionPanel>
        </VExpansionPanels>
      </VCol>
    </VRow>

    <VDivider class="my-8" />

    <!-- ====================== BAGIAN 2: EXPORT ====================== -->
    <VRow>
      <VCol cols="12">
        <div class="d-flex align-center gap-3 mb-3">
          <VAvatar color="success" variant="tonal" size="40" rounded>
            <VIcon icon="ri-download-2-line" size="22" />
          </VAvatar>
          <h5 class="text-h5 font-weight-bold mb-0">Bagian 2 — Export Laporan (Excel & PDF)</h5>
        </div>
      </VCol>
    </VRow>

    <!-- Konsep Export -->
    <VRow>
      <VCol cols="12">
        <VCard>
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-book-open-line" class="me-2" color="success" />
            Apa itu Export Laporan?
          </VCardTitle>
          <VCardText>
            <p class="text-body-2 mb-3">
              <strong>Export</strong> adalah fitur untuk mengunduh data laporan dari
              PintuKasir ke perangkat Anda dalam bentuk file yang bisa dibuka di luar
              aplikasi — yaitu <strong>file Excel (.xlsx)</strong> atau <strong>file PDF (.pdf)</strong>.
            </p>
            <p class="text-body-2 mb-0">
              Dengan export, Anda bisa: membagikan laporan ke akuntan via WhatsApp,
              menyimpan arsip bulanan di folder komputer, menganalisa data lebih dalam
              di Excel, atau mencetak laporan untuk keperluan bank atau investor.
            </p>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- Jenis Export -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VCard>
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-file-list-3-line" class="me-2" color="info" />
            Jenis Laporan yang Bisa Di-export
          </VCardTitle>
          <VCardText>
            <VRow>
              <VCol
                v-for="exp in exportTypes"
                :key="exp.nama"
                cols="12"
                sm="6"
              >
                <VCard variant="outlined" class="h-100">
                  <VCardText>
                    <div class="d-flex align-center gap-2 mb-3">
                      <VAvatar :color="exp.color" variant="tonal" size="36" rounded>
                        <VIcon :icon="exp.icon" size="20" />
                      </VAvatar>
                      <div>
                        <p class="text-body-2 font-weight-bold mb-0">{{ exp.nama }}</p>
                        <VChip :color="exp.color" size="x-small" variant="tonal" label>
                          .{{ exp.format }}
                        </VChip>
                      </div>
                    </div>
                    <p class="text-body-2 mb-2">
                      <strong>Isi file:</strong> {{ exp.isiFile }}
                    </p>
                    <p class="text-caption text-medium-emphasis mb-0">
                      <strong>Cocok untuk:</strong> {{ exp.cocokUntuk }}
                    </p>
                  </VCardText>
                </VCard>
              </VCol>
            </VRow>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- Cara Export Penjualan -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VCard>
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-play-circle-line" class="me-2" color="success" />
            Cara Download Laporan Penjualan
          </VCardTitle>
          <VCardText>
            <ol class="text-body-2 ps-4">
              <li class="mb-3">
                Buka menu <strong>Laporan → Laporan Penjualan</strong> dari sidebar kiri
              </li>
              <li class="mb-3">
                Isi filter di bagian atas halaman:
                <VTable density="compact" class="mt-2 mb-1">
                  <thead>
                    <tr>
                      <th>Field</th>
                      <th>Penjelasan</th>
                      <th>Contoh</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>Dari Tanggal</strong></td>
                      <td class="text-body-2">Tanggal mulai periode laporan</td>
                      <td class="text-body-2">01/07/2025</td>
                    </tr>
                    <tr>
                      <td><strong>Sampai Tanggal</strong></td>
                      <td class="text-body-2">Tanggal akhir periode laporan</td>
                      <td class="text-body-2">31/07/2025</td>
                    </tr>
                    <tr>
                      <td><strong>Kelompokkan</strong></td>
                      <td class="text-body-2">Cara data dikelompokkan dalam laporan</td>
                      <td class="text-body-2">Per Hari / Per Minggu / Per Bulan</td>
                    </tr>
                  </tbody>
                </VTable>
              </li>
              <li class="mb-3">
                Klik tombol <strong>"Tampilkan"</strong> — data akan muncul di tabel bawah
              </li>
              <li class="mb-3">
                Di pojok kanan atas halaman, klik salah satu tombol:
                <div class="d-flex gap-2 mt-2">
                  <VChip color="success" variant="tonal" prepend-icon="ri-file-excel-2-line">
                    Excel
                  </VChip>
                  <span class="text-body-2 d-flex align-center">— untuk file spreadsheet</span>
                </div>
                <div class="d-flex gap-2 mt-1">
                  <VChip color="error" variant="tonal" prepend-icon="ri-file-pdf-2-line">
                    PDF
                  </VChip>
                  <span class="text-body-2 d-flex align-center">— untuk file cetak/kirim</span>
                </div>
              </li>
              <li class="mb-0">
                File otomatis tersimpan di folder <strong>Downloads</strong> perangkat Anda.
                Nama file sudah otomatis diberi nama, contoh:
                <code class="text-caption bg-grey-lighten-4 pa-1 rounded">
                  penjualan_2025-07-01_2025-07-31.xlsx
                </code>
              </li>
            </ol>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- Cara Export Laba Rugi -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VCard>
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-play-circle-line" class="me-2" color="primary" />
            Cara Download Laporan Laba Rugi
          </VCardTitle>
          <VCardText>
            <ol class="text-body-2 ps-4">
              <li class="mb-3">
                Buka menu <strong>Laporan → Laba Rugi</strong> dari sidebar kiri
              </li>
              <li class="mb-3">
                Isi <strong>Dari Tanggal</strong> dan <strong>Sampai Tanggal</strong>.
                <br>
                <span class="text-caption text-medium-emphasis">
                  Contoh: 01/01/2025 sampai 31/03/2025 untuk laporan Q1 tahun ini
                </span>
              </li>
              <li class="mb-3">
                Klik tombol <strong>"Hitung"</strong> — sistem menghitung dan menampilkan tabel
                Laba Rugi yang menampilkan:
                <ul class="mt-1">
                  <li>Omzet Penjualan (total pemasukan)</li>
                  <li>HPP / Harga Pokok Penjualan (biaya bahan baku)</li>
                  <li>Laba Kotor (omzet dikurangi HPP)</li>
                  <li>Biaya Operasional (pengeluaran seperti gaji, listrik, dll)</li>
                  <li>Laba Bersih (apakah toko Anda untung atau rugi)</li>
                </ul>
              </li>
              <li class="mb-3">
                Lihat angka <strong>Gross Margin</strong> dan <strong>Net Margin</strong>
                di bawah tabel. Ini persentase keuntungan dibanding omzet.
                <VAlert type="info" variant="tonal" density="compact" class="mt-2">
                  <strong>Contoh cara baca:</strong> Net Margin 25% artinya dari setiap
                  Rp 100.000 penjualan, Rp 25.000 adalah keuntungan bersih Anda.
                </VAlert>
              </li>
              <li class="mb-0">
                Klik tombol <strong>Excel</strong> atau <strong>PDF</strong> di kanan atas
                untuk download. File tersimpan otomatis di folder Downloads.
                <br>
                <span class="text-caption text-medium-emphasis">
                  Contoh nama file: <code>laba-rugi_2025-01-01_2025-03-31.pdf</code>
                </span>
              </li>
            </ol>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- Tips Export -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VCard color="success" variant="tonal">
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-lightbulb-line" class="me-2" />
            💡 Tips Export Laporan untuk UMKM
          </VCardTitle>
          <VCardText>
            <VList density="compact" bg-color="transparent">
              <VListItem prepend-icon="ri-calendar-event-line" class="mb-2">
                <VListItemTitle class="text-body-2 text-wrap">
                  <strong>Rutinkan export bulanan di awal bulan.</strong>
                  Setiap tanggal 1, download laporan penjualan dan laba rugi bulan sebelumnya.
                  Simpan di folder yang terorganisir: <code>Laporan/2025/Juli/</code>
                </VListItemTitle>
              </VListItem>
              <VListItem prepend-icon="ri-file-copy-2-line" class="mb-2">
                <VListItemTitle class="text-body-2 text-wrap">
                  <strong>Gunakan Excel untuk analisa, PDF untuk presentasi.</strong>
                  Kirim Excel ke akuntan agar bisa diolah lebih lanjut.
                  Cetak atau kirim PDF ke bank, investor, atau mitra bisnis.
                </VListItemTitle>
              </VListItem>
              <VListItem prepend-icon="ri-whatsapp-line">
                <VListItemTitle class="text-body-2 text-wrap">
                  <strong>Mudah dibagikan via WhatsApp.</strong>
                  Download PDF di HP → langsung bisa dikirim ke grup manajemen atau
                  akuntan Anda via WhatsApp. Ukuran file biasanya kecil (di bawah 1 MB).
                </VListItemTitle>
              </VListItem>
            </VList>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- Peringatan Export -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VCard color="warning" variant="tonal">
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-error-warning-line" class="me-2" />
            ⚠️ Hal Penting saat Export
          </VCardTitle>
          <VCardText>
            <VList density="compact" bg-color="transparent">
              <VListItem prepend-icon="ri-refresh-line" class="mb-2">
                <VListItemTitle class="text-body-2 text-wrap">
                  <strong>Klik "Tampilkan" atau "Hitung" sebelum export.</strong>
                  Tombol export hanya aktif setelah data ditampilkan di layar.
                  Jika tombol masih abu-abu, berarti belum ada data yang dimuat.
                </VListItemTitle>
              </VListItem>
              <VListItem prepend-icon="ri-time-line" class="mb-2">
                <VListItemTitle class="text-body-2 text-wrap">
                  <strong>Jangan tutup halaman saat sedang download.</strong>
                  Proses download bisa memakan 5-30 detik tergantung besarnya data.
                  Tunggu hingga file muncul di folder Downloads Anda.
                </VListItemTitle>
              </VListItem>
              <VListItem prepend-icon="ri-database-2-line">
                <VListItemTitle class="text-body-2 text-wrap">
                  <strong>Data yang di-export adalah snapshot saat itu.</strong>
                  Jika ada transaksi baru setelah Anda download, Anda perlu download ulang
                  untuk mendapatkan data terbaru.
                </VListItemTitle>
              </VListItem>
            </VList>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- FAQ Export -->
    <VRow class="mt-4">
      <VCol cols="12">
        <h6 class="text-h6 font-weight-bold mb-3">
          ❓ Pertanyaan Umum tentang Export
        </h6>
        <VExpansionPanels variant="accordion">
          <VExpansionPanel v-for="(item, i) in faqExport" :key="i">
            <VExpansionPanelTitle class="text-body-2 font-weight-medium">
              {{ item.q }}
            </VExpansionPanelTitle>
            <VExpansionPanelText>
              <p class="text-body-2 mb-0">{{ item.a }}</p>
            </VExpansionPanelText>
          </VExpansionPanel>
        </VExpansionPanels>
      </VCol>
    </VRow>

    <!-- Related Links -->
    <VRow class="mt-6 mb-4">
      <VCol cols="12">
        <h5 class="text-h5 font-weight-bold mb-3">🔗 Halaman Terkait</h5>
        <VRow>
          <VCol
            v-for="link in [
              { title: 'Bahan Baku', sub: 'Isi Stok Minimum agar notifikasi bekerja', icon: 'ri-archive-line', color: 'warning', to: '/userguide/produk-inventory/bahan-baku' },
              { title: 'Laporan Penjualan', sub: 'Halaman export laporan penjualan', icon: 'ri-bar-chart-line', color: 'success', to: '/userguide/laporan/penjualan' },
              { title: 'Laba Rugi', sub: 'Halaman export laporan laba rugi', icon: 'ri-money-dollar-circle-line', color: 'primary', to: '/userguide/laporan/laba-rugi' },
              { title: 'User & Role', sub: 'Atur siapa yang terima notifikasi', icon: 'ri-group-line', color: 'info', to: '/userguide/sistem/user-role' },
            ]"
            :key="link.title"
            cols="12"
            sm="6"
            md="3"
          >
            <RouterLink :to="link.to" class="text-decoration-none">
              <VCard variant="outlined" hover>
                <VCardText class="d-flex align-center gap-3 py-3">
                  <VAvatar :color="link.color" variant="tonal" size="36" rounded>
                    <VIcon :icon="link.icon" size="18" />
                  </VAvatar>
                  <div>
                    <p class="text-body-2 font-weight-bold mb-0">{{ link.title }}</p>
                    <p class="text-caption text-medium-emphasis mb-0">{{ link.sub }}</p>
                  </div>
                </VCardText>
              </VCard>
            </RouterLink>
          </VCol>
        </VRow>
      </VCol>
    </VRow>
  </div>
</template>
